import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';
import { Button } from './Button';
import { useLeadModal } from './LeadModalContext';
export function OfferDetails() {
  const {
    openModal
  } = useLeadModal();
  return <div className="w-full" data-id="element-90">
      {/* SECTION 4: PRUEBA SOCIAL */}
      <section className="py-20 px-6 bg-earth text-bunker" data-id="element-91">
        <div className="max-w-5xl mx-auto" data-id="element-92">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-93">
            Ahorradores que ya blindaron su patrimonio
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-94">
            <div className="bg-white p-8 border border-bunker/10 shadow-sm" data-id="element-95">
              <div className="flex text-pitahaya mb-4" data-id="element-96">
                {[...Array(5)].map((_, i) => <span key={i} data-id="element-97">★</span>)}
              </div>
              <p className="font-serif text-lg italic mb-6 leading-relaxed" data-id="element-98">
                "Tenía mis ahorros de 15 años en una cuenta en dólares y vi cómo
                mi poder de compra caía día tras día. Moví mi capital a 5 lotes
                de Pitahaya. Ver mi escritura pública y saber que mi dinero
                ahora es tierra productiva me devolvió el sueño."
              </p>
              <div className="mt-auto border-t border-bunker/10 pt-4" data-id="element-99">
                <p className="font-sans font-bold" data-id="element-100">
                  — C.P. Ricardo H., Monterrey
                </p>
                <p className="font-sans text-sm text-pitahaya font-semibold mt-1" data-id="element-101">
                  Resultado: Blindaje total de ahorros.
                </p>
              </div>
            </div>

            <div className="bg-white p-8 border border-bunker/10 shadow-sm" data-id="element-102">
              <div className="flex text-pitahaya mb-4" data-id="element-103">
                {[...Array(5)].map((_, i) => <span key={i} data-id="element-104">★</span>)}
              </div>
              <p className="font-serif text-lg italic mb-6 leading-relaxed" data-id="element-105">
                "Dudaba de todo lo digital. Yo quería algo que pudiera tocar.
                Fui a Yucatán, puse mis pies en mi lote y vi el sistema de riego
                funcionando. Esto no es una aplicación de celular, es patrimonio
                real para mis hijos."
              </p>
              <div className="mt-auto border-t border-bunker/10 pt-4" data-id="element-106">
                <p className="font-sans font-bold" data-id="element-107">
                  — Dra. Martha G., Guadalajara
                </p>
                <p className="font-sans text-sm text-pitahaya font-semibold mt-1" data-id="element-108">
                  Resultado: Inversión tangible y segura.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 & 6: OFERTA Y PRECIO */}
      <section className="py-24 px-6 bg-bunker text-earth" id="oferta" data-id="element-109">
        <div className="max-w-4xl mx-auto" data-id="element-110">
          <div className="text-center mb-12" data-id="element-111">
            <Lock className="w-12 h-12 text-pitahaya mx-auto mb-6" data-id="element-112" />
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-113">
              El Paquete de Seguridad
            </h2>
            <p className="font-sans text-xl text-earth/70 uppercase tracking-widest" data-id="element-114">
              Oferta de Blindaje Patrimonial — Este Año
            </p>
          </div>

          <div className="bg-bunker border-2 border-pitahaya p-8 md:p-12 relative" data-id="element-115">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-pitahaya -translate-x-2 -translate-y-2 bg-bunker" data-id="element-116"></div>
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-pitahaya translate-x-2 -translate-y-2 bg-bunker" data-id="element-117"></div>
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-pitahaya -translate-x-2 translate-y-2 bg-bunker" data-id="element-118"></div>
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-pitahaya translate-x-2 translate-y-2 bg-bunker" data-id="element-119"></div>

            <div className="space-y-6 mb-10" data-id="element-120">
              <div className="flex items-start gap-4 pb-6 border-b border-white/10" data-id="element-121">
                <CheckCircle className="w-6 h-6 text-pitahaya shrink-0 mt-1" data-id="element-122" />
                <div data-id="element-123">
                  <h4 className="font-sans font-bold text-lg" data-id="element-124">
                    Lote de 200m2 Propiedad Privada
                  </h4>
                  <p className="text-earth/60 text-sm mt-1" data-id="element-125">
                    Valor: $120,000 MXN
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-white/10" data-id="element-126">
                <CheckCircle className="w-6 h-6 text-pitahaya shrink-0 mt-1" data-id="element-127" />
                <div data-id="element-128">
                  <h4 className="font-sans font-bold text-lg" data-id="element-129">
                    Gestión Agrícola "Hands-Off" (20 años)
                  </h4>
                  <p className="text-earth/80 mt-1" data-id="element-130">
                    Nosotros operamos, tú descansas.
                  </p>
                  <p className="text-earth/60 text-sm mt-1" data-id="element-131">
                    Valor: $45,000 MXN
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-white/10" data-id="element-132">
                <CheckCircle className="w-6 h-6 text-pitahaya shrink-0 mt-1" data-id="element-133" />
                <div data-id="element-134">
                  <h4 className="font-sans font-bold text-lg text-pitahaya" data-id="element-135">
                    Bonus #1: Guía de Blindaje Patrimonial
                  </h4>
                  <p className="text-earth/80 mt-1" data-id="element-136">
                    Estrategias para proteger tu capital en crisis.
                  </p>
                  <p className="text-earth/60 text-sm mt-1" data-id="element-137">
                    Valor: $2,500 MXN
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-white/10" data-id="element-138">
                <CheckCircle className="w-6 h-6 text-pitahaya shrink-0 mt-1" data-id="element-139" />
                <div data-id="element-140">
                  <h4 className="font-sans font-bold text-lg text-pitahaya" data-id="element-141">
                    Bonus #2: Dictamen Legal de Certeza Jurídica
                  </h4>
                  <p className="text-earth/80 mt-1" data-id="element-142">
                    Copias de títulos y permisos.
                  </p>
                  <p className="text-earth/60 text-sm mt-1" data-id="element-143">
                    Valor: $3,000 MXN
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-white/10" data-id="element-144">
                <CheckCircle className="w-6 h-6 text-pitahaya shrink-0 mt-1" data-id="element-145" />
                <div data-id="element-146">
                  <h4 className="font-sans font-bold text-lg text-pitahaya" data-id="element-147">
                    Bonus #3: Acceso al Sistema de Exportación
                  </h4>
                  <p className="text-earth/80 mt-1" data-id="element-148">Tu parte del "Oro Rosa".</p>
                  <p className="text-earth/60 text-sm mt-1" data-id="element-149">
                    Valor: $15,000 MXN
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mb-10" data-id="element-150">
              <p className="font-sans text-lg text-earth/60 line-through mb-2" data-id="element-151">
                VALOR TOTAL DE TU SEGURIDAD: $185,500 MXN
              </p>
              <p className="font-sans text-sm text-earth/80 mb-6 max-w-2xl mx-auto" data-id="element-152">
                No permitas que la inflación decida por ti. Históricamente, en
                crisis, quien tiene tierra tiene el poder. Hoy aseguramos tu
                futuro por una fracción de su valor futuro:
              </p>
              <div className="inline-block bg-pitahaya px-8 py-4" data-id="element-153">
                <p className="font-sans font-bold text-sm uppercase tracking-widest mb-1" data-id="element-154">
                  Tu Inversión Hoy
                </p>
                <p className="font-serif text-5xl md:text-6xl font-bold" data-id="element-155">
                  SOLO $89,000 MXN
                </p>
              </div>
              <p className="font-sans text-sm text-earth/60 mt-4 italic" data-id="element-156">
                (O congela tu precio con un enganche de $15,000 MXN y
                mensualidades fijas sin intereses)
              </p>
            </div>

            <div className="text-center" data-id="element-157">
              <Button fullWidth className="md:w-auto md:px-16 md:py-5 text-lg" onClick={openModal} data-id="element-158">
                Reservar Mi Lote Ahora
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}